import React from "react";
import { View, StyleSheet, TouchableOpacity, Text, Platform } from "react-native";

export default function ShowMoreItems({
  hasMoreItems = false,
  message,
  onPress = () => {},
}) {
  return (
    <>
      {hasMoreItems ? (
        <View style={styles.moreWrapper}>
          <TouchableOpacity activeOpacity={0.9} onPress={onPress}>
            <Text style={styles.message}>{message}</Text>
          </TouchableOpacity>
        </View>
      ) : null}
    </>
  );
}

const styles = StyleSheet.create({
  moreWrapper: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    height: 40,
  },
  message: {
    color: "#768B9D",
    fontFamily:  Platform.select({ default: "Montserrat", android: "Montserrat-SemiBold" }),
    fontWeight: "600",
    fontSize: 10,
    lineHeight: 12,
    letterSpacing: 0.175,
  },
});
